import styled from 'styled-components'

export const Content = styled.div`
  margin: 16px 4px;
  max-width: 14rem;
  min-width: 8rem;
`
